import { connect } from "react-redux";
import Home from "./Home";
import { getHomeSubscription } from "../../selectors/subscriptionSelectors";

function mapStateToProps(state) {
  return {
    subscriptions: getHomeSubscription(state),
  };
}

export default connect(mapStateToProps)(Home);
